import { IEntitlement } from 'API/compassRights';
import { createContext, ReactNode, useReducer } from 'react';
import { CategoriesFilterReducer } from 'reducer/CompassRights/CategoriesFilterReducer';
import { EntitlementsReducer } from 'reducer/CompassRights/EntitlementsReducer';

interface IEntitlementsContext {
  entitlements: IEntitlementsState;
  dispatchEntitlements: Function;
  categories: ICategoriesState[];
  dispatchCategories: Function;
}

export const EntitlementsContext = createContext<IEntitlementsContext>({
  entitlements: {
    allEntitlements: [],
    filteredEntitlements: [],
  },
  dispatchEntitlements: () => {},
  categories: [],
  dispatchCategories: () => {},
});

export interface IEntitlementsState {
  allEntitlements: IEntitlement[];
  filteredEntitlements: IEntitlement[];
}

export interface ICategoriesState {
  id: number;
  name: string;
  checked?: boolean;
  subCategories: ICategory[];
}

export interface ICategory {
  id: number;
  name: string;
  checked?: boolean;
}

type Props = { children: ReactNode };

export const EntitlementsContextProvider = ({ children }: Props) => {
  const [entitlements, dispatchEntitlements] = useReducer(EntitlementsReducer, {
    allEntitlements: [],
    filteredEntitlements: [],
  });

  const [categories, dispatchCategories] = useReducer(
    CategoriesFilterReducer,
    []
  );

  return (
    <EntitlementsContext.Provider
      value={{
        entitlements,
        dispatchEntitlements,
        categories,
        dispatchCategories,
      }}
    >
      {children}
    </EntitlementsContext.Provider>
  );
};
